export default __webpack_public_path__ + "static/abcares-build-fe8a85ed9d2b584915066a5225c965c4.jpg";